import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_TRANSPORT_METHOD } from 'appConstants';
import useValidations from 'hooks/useValidations';

export default function useValidationSchema(isDebtOwner?: boolean) {
  const { t } = useTranslation('CreateOrder', { keyPrefix: 'ProductForm.labels' });

  const { createSchema } = useValidations();
  return useMemo(() => {
    const fields = [
      {
        type: 'string',
        ruleName: 'internalOrderId',
      },
      {
        type: 'requiredString',
        label: t('bagSize'),
        ruleName: 'packagedItemReference',
      },
      {
        type: 'requiredString',
        label: t('productName'),
        ruleName: 'itemGroupRef',
      },
      {
        type: 'packagedItemQty',
        label: t('bulkQuantity'),
      },
      {
        type: 'packagedItemPrice',
        label: t('price'),
      },
      {
        type: 'businessUser',
        label: '',
        context: {
          labels: {
            businessName: t('businessName'),
            businessContact: t('businessContact'),
          },
        },
      },
      {
        type: 'paymentTerms',
        label: t('paymentTerms'),
        context: {
          isDebtOwner,
          labels: {
            paymentDue: t('paymentDue'),
          },
        },
      },

      {
        type: 'string',
        label: t('notes'),
        ruleName: 'packagedItemNotes',
      },
      {
        type: 'startDate',
        label: t('startDate'),
      },
      {
        type: 'endDate',
        label: t('endDate'),
        context: {
          startDateLabel: t('startDate'),
        },
      },

      {
        type: 'requiredString',
        label: t('transportMethod'),
        ruleName: 'transportMethod',
        defaultValue: DEFAULT_TRANSPORT_METHOD,
      },
      {
        type: 'requiredNumber',
        label: t('deliveryAddress'),
        ruleName: 'addressNumber',
      },
    ];
    return createSchema(fields);
  }, [createSchema, isDebtOwner, t]);
}
